import { render, staticRenderFns } from "./EmailCaptureRoadblock.vue?vue&type=template&id=450745f1&scoped=true&"
import script from "./EmailCaptureRoadblock.vue?vue&type=script&lang=js&"
export * from "./EmailCaptureRoadblock.vue?vue&type=script&lang=js&"
import style0 from "./EmailCaptureRoadblock.vue?vue&type=style&index=0&id=450745f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450745f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
